class NotificationList {
	constructor(button) {
		this._button = ge(button);

		if (this._button === null) return;
		
		onEv(this._button, 'click', this.showNotifications.bind(this));

		this.countElem = div('notification-count animated norm');
		this._button.appendChild(this.countElem);

		this._list = Dialog.Popup(
			'notifications',
			this._listElem = div('notification-list'), 
			'below-left',
			_("NOTIFICATIONS")
		).sticky();

		this.getCount();
		this.init();
	}

	init() {
		ajg('notification/permissions', null, null, (reply) => {
			this._permissions = reply;
		});
	}

	getCount() {
		ajg('notification/count', null, null, (reply) => {
			if (reply.count) this.showCount(reply.count);
		});
	}

	showCount(value) {
		if (0 < value) {
			this.countElem.innerHTML = value;
			state(this.countElem, 'active');
		}
		else {
			state(this.countElem);
		}
	}

	showNotifications() {
		this._list.handle(this._button);
		while (this._listElem.firstChild) this._listElem.removeChild(this._listElem.firstChild);
		ajg('notification/list', null, null, (reply) => {
			if (reply.notes && Array.isArray(reply.notes)){
				reply.notes.forEach(data => {
					let note = NotificationItem.fromArray(data, this);
					this._listElem.appendChild(note.build(reply.templates[note.type]));
				});
			}
		});
	}

	checkPermission(type) {
		return this._permissions[type] === 1;
	}
}